import { render, staticRenderFns } from "./PlaceCategoryModal.vue?vue&type=template&id=c8a26676&scoped=true&"
import script from "./PlaceCategoryModal.vue?vue&type=script&lang=js&"
export * from "./PlaceCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./PlaceCategoryModal.vue?vue&type=style&index=0&id=c8a26676&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a26676",
  null
  
)

export default component.exports